import React from 'react';
import { LocationMarkerIcon } from '../../icons';
import './VenueListing.css';

export interface VenueListingProps {
  name: string;
  location?: string;
  imageUrl?: string;
  onClick?: () => void;
}

export const VenueListing: React.FC<VenueListingProps> = ({
  name,
  location,
  imageUrl,
  onClick,
}) => {
  return (
    <div className="venue-listing" onClick={onClick}>
      <div className="venue-listing__image">
        {imageUrl ? (
          <img src={imageUrl} alt="" />
        ) : (
          <LocationMarkerIcon style={{ width: '26px', height: '26px' }} color="rgba(171, 171, 171, 0.8)" />
        )}
      </div>
      <div className="venue-listing__content">
        {location && <div className="venue-listing__location">{location}</div>}
        <div className="venue-listing__name">{name}</div>
      </div>
    </div>
  );
};
